export default "__VITE_PUBLIC_ASSET__5dba162d__"